import React, { Component } from 'react';
import language from '../../assets/languages/language';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { fetchFreeUseSubscriptionMessage } from '../../services/exams';
import { renderHTMLContent } from '../../common/function';

class ModalComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { subscriptionMessage: props.MessageContent };
  }

  toggleAlert(event) {
    event.preventDefault();
    this.props.toggleAlert(event);
  }

  goPremium(event) {
    event.preventDefault();
    this.props.goPremium(event);
  }

  componentDidMount() {
    const { exam } = this.props;
    if (exam) {
      this.setContentMessage();
    }
  }

  setContentMessage = async () => {
    const result = await fetchFreeUseSubscriptionMessage({
      exam: this.props.exam,
      section: 'modal',
    });
    if (result.success && result.data) {
      const { html_content = '', header } = result.data;
      this.setState({
        subscriptionMessage: html_content,
        contentHeader: header,
      });
    }
  };

  render() {
    const { alert_status } = this.props;
    const { subscriptionMessage } = this.state;
    return (
      <Modal
        isOpen={alert_status}
        toggle={this.toggleAlert.bind(this)}
        className={`modal-primary custom_modalpro info-modal-designing ${this.props.className}`}
      >
        <ModalHeader toggle={this.toggleAlert.bind(this)} className='custom-title'>
          {language.LC().INFORMATION}{' '}
        </ModalHeader>
        <ModalBody className=''>
          <div className='modal-info-view-for-plan '>
            <h4>{language.LC().Why_should_I_upgrade_my_account}</h4>
            {renderHTMLContent(subscriptionMessage, "div", "", { contentEditable: "false" })}
            <div className='btn-plan-view view-plan-wrap'>
              <Button
                className='btn btn-primary margin_right_20'
                onClick={this.toggleAlert.bind(this)}
              >
                {' '}
                {language.LC().KEEP_FREE_VERSION}{' '}
              </Button>
              <Button className='btn btn-primary' onClick={this.goPremium.bind(this)}>
                {' '}
                {language.LC().GO_PREMIUM}{' '}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default ModalComponent;



// WEBPACK FOOTER //
// ./src/views/Common/Modal.js